import { Modal, ModalBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";

const PREMIUM_FEATURES = (t) => [
  t('business.components.upgrade_modal.features.role_management', "Custom Role Management"),
  t('business.components.upgrade_modal.features.permissions', "Advanced User Permissions"),
  t('business.components.upgrade_modal.features.multi_location', "Multi-Location Support"),
  t('business.components.upgrade_modal.features.priority_support', "Priority Support"),
  t('business.components.upgrade_modal.features.reporting', "Advanced Reporting"),
  t('business.components.upgrade_modal.features.api_access', "API Access"),
];

const UpgradeModal = ({ isOpen, toggle }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalBody className="p-4 p-md-5 text-center">
        {/* Close button */}
        <button
          type="button"
          className="btn-close position-absolute"
          style={{ top: "1rem", right: "1rem" }}
          onClick={toggle}
          aria-label={t('shared.close', 'Close')}
        />

        {/* Icon */}
        <div className="mb-4">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mx-auto"
            style={{
              width: 80,
              height: 80,
              backgroundColor: "rgba(var(--bs-primary-rgb), 0.1)",
            }}
          >
            <FeatherIcon icon="lock" size={36} className="text-primary" />
          </div>
        </div>

        {/* Title */}
        <h3 className="mb-2">{t('business.components.upgrade_modal.title', 'Premium Feature')}</h3>
        <p className="text-muted mb-4">
          {t('business.components.upgrade_modal.description', 'Custom roles are available on our Enterprise plan. Upgrade to unlock the full power of ArcMedix.')}
        </p>

        {/* Features list */}
        <div className="text-start mb-4">
          <div className="row">
            {PREMIUM_FEATURES(t).map((feature, index) => (
              <div key={index} className="col-6 mb-2">
                <div className="d-flex align-items-center gap-2">
                  <FeatherIcon
                    icon="check-circle"
                    size={18}
                    className="text-primary"
                  />
                  <span>{feature}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <button
          type="button"
          className="btn btn-primary btn-lg px-5"
          onClick={() => {
            window.open("mailto:sales@arcmedix.com?subject=Enterprise Plan Inquiry", "_blank");
          }}
        >
          {t('shared.contact_sales', 'Contact Sales')}
        </button>
      </ModalBody>
    </Modal>
  );
};

export default UpgradeModal;
